import { Injectable, inject, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BreadcrumbItem } from '../../core/models/breadcrumb.model';

// Pages push their trail here; the shell's breadcrumb bar renders it.
// The trail clears on every navigation, so pages that set nothing show no bar.
@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private readonly trail = signal<BreadcrumbItem[]>([]);
  readonly crumbs = this.trail.asReadonly();

  constructor() {
    inject(Router).events.subscribe(event => {
      if (event instanceof NavigationStart) this.trail.set([]);
    });
  }

  set(crumbs: BreadcrumbItem[]): void {
    this.trail.set(crumbs);
  }
}
